import cookie from "./_cookie";
import {addToCartHandler} from "./addToCart";

const productBundles = document.querySelector('.js-product-bundles');

if(productBundles) {
    document.addEventListener('bundler:loaded', function (e) {

        if (typeof window.bndlr !== 'undefined' && typeof window.bndlr.getBundles === 'function') {
            const bundles = window.bndlr.getBundles();
            const bundleForm = productBundles.querySelector('.js-product-bundle-form');
            const title = productBundles.querySelector('h3');
            const bundle = bundles[0];
            const bundleProduct = productBundles.querySelector('.js-product-bundle');
            const bundleTotalsPrice = productBundles.querySelector('.js-product-totals-price');
            const bundleTotalsDiscountPrice = productBundles.querySelector('.js-product-totals-discount-price');
            const discountAmount = bundle.percentage_value;
            const productHandlers = [];

            title.innerHTML = bundle.name;

            for (let bundleProduct in bundle.products) {
                productHandlers.push(bundle.products[bundleProduct].handle);
            }
            async function fetchProducts() {
                for (const productHandle of productHandlers) {
                    try {
                        let bundlePrice = 0;
                        let productIds = [];
                        const response = await fetch(`/products/${productHandle}?section_id=product-block-by-id-bundle`);
                        const html = await response.text();

                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        bundleProduct.insertAdjacentHTML('beforeend', doc.querySelector('.js-product-data').innerHTML);
                        const bundleProducts =  productBundles.querySelectorAll('.js-product-block');

                        bundleProducts.forEach((bundleProduct, index, array) => {
                            bundlePrice += parseInt(bundleProduct.querySelector('.js-price').dataset.price);
                            let inputs = '<input type="hidden" name="id" value="' + bundleProduct.dataset.id + '"><input type="hidden" name="quantity" value="1">';

                            if (index === array.length - 1) {
                                bundleForm.innerHTML += inputs;
                            }

                        });

                        const discountPrice = Math.round(bundlePrice - (bundlePrice * (discountAmount / 100)));

                        bundleTotalsPrice.innerHTML = bundlePrice / 100;
                        bundleTotalsDiscountPrice.innerHTML = discountPrice / 100;
                        bundleTotalsPrice.innerHTML = bundleTotalsPrice.innerHTML.replace(/\./g, ",");
                        bundleTotalsDiscountPrice.innerHTML = bundleTotalsDiscountPrice.innerHTML.replace(/\./g, ",");


                    } catch (error) {
                        console.error(error);
                    }
                }
            }
            fetchProducts();

            bundleForm.addEventListener('submit', addToCartHandler);

           //console.log(bundles);

// This is how the event is triggered
//             window.bndlr.getCheckoutInfo(
//                 function(data) {
//                     console.log(data);
//                     if (typeof data !== 'undefined' && typeof data.can_apply_discount !== 'undefined' && data.can_apply_discount === true) {
//                         // Do your magic with the discount
//                     } else {
//                         // Discount can't be applied
//                     }
//
//                     // Data object in this callback will contain properties
//                     // can_apply_discount: Boolean	<-- whether the app has any discount to apply or not
//                     // code: String 				<-- discount code, if applicable (the merchant must turn on the option to apply discounts with discount codes in Bundler > General Settings > Apply discounts).
//                     // items: Array[], 				<-- items with detailed pricing and discount info
//                     // status_code: Integer, 		<-- status code, 200 means OK, 201 means that the draft order is not yet ready
//                     // url: String 					<-- URL to which the customer would get redirected to get a discount. If a discount code is used, then it will contain a discount code, if a draft order is used then a link to the draft order will be here.
//                 }
//             );

            //window.bndlr.checkout();
        }
    });
}